import { useEffect, useState } from 'react';
import { Users } from 'lucide-react';
import type { SegmentationCriteria } from '@/shared/types/segmentation';
import { previewSegmentationCount } from '../api/use-segmentations';

interface Props {
  idPassbook: string;
  criteria: SegmentationCriteria;
}

/** Contagem AO VIVO enquanto o usuário edita o canvas -- espelha
 * features/campaigns/ui/campaign-audience-preview.tsx (mesmo debounce de
 * 400ms). Nunca é isso que o disparo usa -- só UX do construtor. Sem condição
 * nenhuma já conta: é a base com push (filtro base fixo da legacy-api). */
export function SegmentationAudiencePreview({ idPassbook, criteria }: Props) {
  const [count, setCount] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const timer = setTimeout(async () => {
      setLoading(true);
      try {
        const total = await previewSegmentationCount(idPassbook, criteria);
        setCount(total);
      } catch {
        setCount(null);
      } finally {
        setLoading(false);
      }
    }, 400);
    return () => clearTimeout(timer);
  }, [idPassbook, criteria]);

  const countLabel = loading ? '…' : count != null ? count.toLocaleString('pt-BR') : '—';

  return (
    <p className="flex shrink-0 items-center gap-1.5 text-sm" title="Leads na segmentação (só com push disponível)">
      <Users className="size-3.5 shrink-0 text-success" aria-hidden />
      <span className="font-semibold tabular-nums text-primary">{countLabel}</span>
      <span className="hidden text-muted-foreground sm:inline">leads</span>
    </p>
  );
}
